module.exports = __webpack_public_path__ + "img/trouble.dfa77807.png";